import Column from '@app/store/bulkRequest/form/Column';
import ColumnType from '@app/store/bulkRequest/form/ColumnType';
import { getColumnList, getColumnRequesterInputList } from '@app/store/bulkRequest/form/state';
import { getColumnValues } from '@app/store/bulkRequest/requestTasks/tasks/selectors';
import { RootState } from '@app/store/types';

/**
 * 대량전송 전체 state를 반환합니다.
 */
export const getBulkRequest = (state: RootState) => state.bulkRequest;

/**
 * 태스크의 값 중 ColumnType에 해당하는 값을 반환합니다.
 */
export const getColumnValue = (state: RootState, props: { id: string; type: ColumnType }) => {
  const columnList = getColumnList(state);
  const { id, type } = props;
  const columnValues = getColumnValues(state, { id });
  const documentTitleColumn = columnList.find((column: Column) => column.type === type);
  if (documentTitleColumn && columnValues && columnValues.length >= documentTitleColumn.order) {
    return columnValues[documentTitleColumn.order - 1];
  }
  return null;
};

/**
 * 태스크의 요청자 입력 값을 배열로 반환합니다.
 */
export const getRequesterInputValues = (state: RootState, props: { id: string }) => {
  const { id } = props;
  const columnList = getColumnRequesterInputList(state);
  const columnValues = getColumnValues(state, { id });
  return columnList.map((column) => {
    return columnValues && column.order <= columnValues.length
      ? columnValues[column.order - 1]
      : '';
  });
};
